import React from 'react';
import styled from 'styled-components';
import { Form, TogglePanel } from './../../controls';
import { Convert } from './../../../services';

const ResultFormWrapper = styled.div`

`;

const ResultFormTitle = styled.h3`
	margin-bottom: 5px;
`;

const ResultData = styled.div`

`;

const ResultContWrapper = styled.div`
	position: relative;
`;

const ResultItemWrapper = styled.div`
	color: #0798ff;
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	span {
    font-size: 1.5em;
    margin-left: 20px;
	}

	h4 {
		padding-bottom: 0;
		margin-bottom: 0;
  }

	@media(max-width: 670px) {
		align-items: flex-end;
		span {
			font-size: 1.2em;
		}
  }
`;

const ResultItem = ({ title, type, value, info, control, ...props }) => {
	return (
		<ResultData>
			{control && React.createElement(control, props)}
			<ResultContWrapper>
				<div style={{ marginRight: '40px', position: 'relative' }} id='result'>
					<ResultItemWrapper>
						<h4>{title}</h4>
						<span>{type === 'currency' ? Convert.toCurrency(value) : value}</span>
					</ResultItemWrapper>
					<svg height='2px' width='100%' style={{ position: 'absolute' }} >
						<line x1='0' y1='0' x2='100%' y2='0' style={{ stroke: '#0798ff', strokeWidth: '4' }} />
					</svg>
				</div>
				{info && <TogglePanel>{info}</TogglePanel>}
			</ResultContWrapper>
		</ResultData>
	);
};

export const Results = ({ title, data = {}, results = {}, schema, onChange }) => {
	return (
		<ResultFormWrapper>
			<ResultFormTitle>{title}</ResultFormTitle>
			<Form.Wrapper>
				{
					Object.keys(schema).map((resultName) => {
						const { name, label, info, renderer, type } = schema[resultName];
						const commonProps = { title: label, type, info, value: results[resultName], data };
						const sendProps = renderer ? { ...commonProps, control: renderer, onChange: val => onChange({ [name]: val }) } : commonProps;
						return (
							<Form.Row key={resultName} style={{ paddingTop: '5px', paddingBottom: '5px' }} >
								<ResultItem {...sendProps} />
							</Form.Row>
						);
					})
				}
			</Form.Wrapper>
		</ResultFormWrapper>
	);
};

export default Results;



// WEBPACK FOOTER //
// ./src/html/components/Results/index.js